import { InputAdornment as MaterialInputAdornment } from '@material-ui/core';
import { Theme, withStyles, makeStyles } from '@material-ui/core/styles';

export const StyledInputAdornment = withStyles(({ palette }: Theme) => ({
  root: {
    color: palette.text.primary,
  },
  positionEnd: {},
  // @ts-expect-error - Material-UI v4 styled component type conflict with React 18
}))(MaterialInputAdornment);

export const useStyles = makeStyles(({ palette }) => ({
  error: {
    color: palette.error.main,
  },
  success: {
    color: palette.primary.main,
  },
}));
